declare global {
  interface Window {
    fathom?: { trackEvent: (name: string) => void };
  }
}

export type TrackedEvent =
  | "buy"
  | "ks_referral"
  | "psg_discord"
  | "psg_patreon"
  | "psg_youtube";

export function trackEvent(event: TrackedEvent) {
  window.fathom?.trackEvent(event);
}
